export const DIAGNOSTIC_TOOLS_LABEL = 'Diagnostic Tools';
